import styled from 'styled-components';

export const Favorite = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  cursor: pointer;
`;
